import { motion } from 'framer-motion';
import { useState } from 'react';
import { FaShieldAlt, FaUserTag } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import ROLE from '../common/role';
import { request } from '../helpers/request';

const ChangeUserRole = ({
    name,
    email,
    role,
    userId,
    onClose,
    callFunc,
}) => {
    const [userRole, setUserRole] = useState(role)

    const handleOnChangeSelect = (e) => {
        setUserRole(e.target.value)
    }

    const updateUserRole = async () => {
        const response = await request(SummaryApi.updateUser, {
            body: JSON.stringify({
                userId: userId,
                role: userRole
            })
        })

        const responseData = await response.json()

        if (responseData.success) {
            toast.success("Role updated successfully")
            onClose()
            callFunc()
        } else {
            toast.error(responseData.message)
        }
    }

    return (
        <div className='fixed inset-0 w-full h-full z-50 flex items-center justify-center p-4'>
            {/* Backdrop */}
            <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className='absolute inset-0 bg-primary/40 backdrop-blur-sm'
                onClick={onClose}
            />

            {/* Modal */}
            <motion.div 
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                className='relative bg-white w-full max-w-md rounded-[2.5rem] shadow-premium overflow-hidden'
            >
                {/* Close Button */}
                <button 
                    className='absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-surface-muted text-gray-400 hover:bg-primary hover:text-white transition-all z-10' 
                    onClick={onClose}
                >
                    <IoMdClose size={20}/>
                </button>

                <div className='p-10'>
                    <div className='flex items-center gap-4 mb-8'>
                        <div className='w-14 h-14 bg-accent/10 rounded-2xl flex items-center justify-center text-accent'>
                            <FaShieldAlt size={24} />
                        </div>
                        <div>
                            <h1 className='text-2xl font-black text-primary tracking-tight'>Update Access</h1>
                            <p className='text-gray-500 font-medium text-sm'>Modify user permissions</p>
                        </div>
                    </div>

                    <div className='space-y-6'>
                        <div className='bg-surface-muted/30 p-6 rounded-2xl border border-surface-border/50'>
                            <div className='space-y-3'>
                                <div>
                                    <p className='text-[10px] font-black uppercase tracking-widest text-gray-400 mb-1'>Full Name</p>
                                    <p className='font-bold text-primary capitalize leading-tight'>{name}</p>
                                </div>
                                <div className='pt-3 border-t border-surface-border'>
                                    <p className='text-[10px] font-black uppercase tracking-widest text-gray-400 mb-1'>Email Address</p>
                                    <p className='font-bold text-primary text-sm'>{email}</p>
                                </div>
                            </div>
                        </div>

                        <div className='space-y-3'>
                            <label className='flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-gray-400'>
                                <FaUserTag size={12} className='text-accent' />
                                Assign New Role
                            </label>
                            <div className='relative'>
                                <select 
                                    className='w-full bg-white border-2 border-surface-border rounded-2xl px-6 py-4 font-bold text-primary appearance-none focus:border-primary transition-all outline-none cursor-pointer' 
                                    value={userRole} 
                                    onChange={handleOnChangeSelect}
                                >
                                    {Object.values(ROLE).map(el => (
                                        <option value={el} key={el}>{el}</option>
                                    ))}
                                </select>
                                <div className='absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400'>
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <button 
                            className='w-full py-5 bg-primary text-white font-black rounded-2xl hover:bg-accent transition-all shadow-xl shadow-primary/20 active:scale-[0.98] mt-4' 
                            onClick={updateUserRole}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}

export default ChangeUserRole